import {useTranslation} from '@aboutyou/i18n';
import {useCurrentPageType, useIsInitialLocation} from '@aboutyou/router';
import {useValueAfterHydration} from '@aboutyou/ui-components';
import React from 'react';
import {useQuickViewVariant} from '../../ArticleDetail/QuickView/useQuickViewVariant';
import {useAppUrlParams} from '../../Checkout/hooks/useAppUrlParams';
import {HeaderInstallBannerWrapper} from './HeaderInstallBannerWrapper';
import {TrackedInstallBanner} from './TrackedInstallBanner';
import {sharedBannerData} from './installBannerData';
import {useAppDetails} from './useAppDetails';
import {useIsAppInstalled} from './useIsAppInstalled';
import {useIsBannerOpen} from './useIsBannerOpen';
interface HeaderInstallBannerProps {
  onClose(options?: {
    disableAnimation?: boolean;
    setLastTimeClosed?: boolean;
  }): void;
}

export function HeaderInstallBanner({onClose}: HeaderInstallBannerProps) {
  const appDetails = useValueAfterHydration(useAppDetails());
  const {t} = useTranslation();
  const goToAppLabel = t('Go to app');
  const {isInstalled, isLoading} = useIsAppInstalled();
  const {device} = useAppUrlParams();
  const {shouldHideTemporarily} = useIsBannerOpen();
  const pageType = useCurrentPageType();
  const isInitialLocation = useIsInitialLocation();
  const isQuickViewV2 = useQuickViewVariant() === 'quickViewV2';

  const isOpenedByTheApp = device;

  if (isOpenedByTheApp) {
    return <HeaderInstallBannerWrapper $empty />;
  }

  if (
    (isInitialLocation && pageType === 'checkout') ||
    isQuickViewV2 ||
    shouldHideTemporarily
  ) {
    return null;
  }

  return (
    <TrackedInstallBanner
      {...(appDetails || sharedBannerData)}
      onClose={onClose}
      isLoading={isLoading}
      isInstalled={isInstalled}
      goToAppLabel={goToAppLabel}
    />
  );
}
